module.exports = __webpack_public_path__ + "static/img/equipmentu2.2083aca7.png";